// import { getTargetURL } from '../app-common-functions';
import { CFHttpClient } from '../shared/cf-http-client';
import { environment } from '../../environments/environment';

/**
 * EAI CONFIG
 *
 * EAI expects the following keys on the body data sent to the server. Each key
 * value is the url of a JSON file in the assets folder that contains the correct
 * page URL to navigate to.
 *
 * NOTE: as pages are completed or if routeing URL's change the files will have to
 * be updated.
 */ 

export function getEAIConfig() {
  //if(environment.name === 'stg'){
    return {
      // Success Scenario
      eai_success_url:
        CFHttpClient.targetURL + '/mas/pub/loginSuccess.json',

      // Valid credentials but failed to log in user scenario
      eai_cr_url: 
        CFHttpClient.targetURL + '/mas/pub/handleEAIResponse.json?status=LOGIN_CHALLRESP',

      // Successful login but user needs to select security image
      eai_image_url:
        CFHttpClient.targetURL + '/mas/pub/handleEAIResponse.json?status=LOGIN_SECIMG' ,

      // Successful login but user needs to reset expired password
      eai_pwexpired_url:
        CFHttpClient.targetURL + '/mas/pub/handleEAIResponse.json?status=LOGIN_PWD_EXPRED',

      // Successful login but users password is expiring so they need to reset
      eai_pwexpiring_url:
        CFHttpClient.targetURL + '/mas/pub/handleEAIResponse.json?status=LOGIN_PWD_EXPRING',

      // Successful login but user needs to change username and password
      eai_idchange_url:
        CFHttpClient.targetURL + '/mas/pub/handleEAIResponse.json?status=LOGIN_UIDCHG',

      // Faiure scenario (needs more investigation)
      eai_to_be_locked_url:
        CFHttpClient.targetURL + '/mas/pub/handleEAIResponse.json?status=LOGIN_TOBELCKD',

      // Failure
      eai_failure_url: 
        CFHttpClient.targetURL + '/mas/pub/handleEAIResponse.json?status=LOGIN_FAILED',

      // Successful login but user needs to pass Multi-factor Authentication
      eai_mfa_url: 
      CFHttpClient.targetURL + '/mas/pub/handleEAIResponse.json?status=LOGIN_MFA',
    };
}



// WEBPACK FOOTER //
// ./src/app/new-login/new-login-eai-config.ts